import { BasketballEventsSlice } from '@hefe/store';
import { Col, Divider, Empty, Row } from 'antd';
import dayjs from 'dayjs';
import { t } from '@hefe/i18n';
import { useSelector } from 'react-redux';
import CustomList from '../../../core/components/custom-list/custom-list.component';
import EventDateBoxComponent from '../event-date-box/event-date-box.component';
import UserEventListItem from '../list-items/user-event-list-item';

interface EventGrouping {
  weekOfYear: number;
  year: number;
  dates: any;
}

export default function UserEventsComponent() {
  const filteredEvents = useSelector(
    BasketballEventsSlice.filteredBasketballUserEvents
  );

  const groupedEvents = (dates: any) => {
    const returnValue: EventGrouping[] = [];

    for (const date in dates) {
      const day = dayjs(date);
      const weekOfYear = day.week();
      const year = day.year();

      const weekIndex = returnValue.findIndex(
        (week) => week.year === year && week.weekOfYear === weekOfYear
      );
      if (weekIndex < 0) {
        returnValue.push({
          weekOfYear: weekOfYear,
          year: year,
          dates: [],
        });
      }

      returnValue[returnValue.length - 1].dates.push({
        date: date,
        events: dates[date],
      });
    }

    return returnValue;
  };

  const events = groupedEvents(filteredEvents);

  const renderList = () => {
    if (events.length === 0) {
      return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
    }
    return (
      <CustomList
        itemLayout="horizontal"
        dataSource={events}
        renderItem={(item: EventGrouping, i) => {
          const days: any[] = [];
          for (const day of item.dates) {
            const items: any[] = [];
            for (const event of day.events) {
              items.push(<UserEventListItem event={event} key={i} />);
            }

            days.push(
              <Row gutter={[{}, { xs: 10, sm: 10, md: 0 }]} key={day.date}>
                <Col xs={24} sm={24} md={3} style={{ textAlign: 'center' }}>
                  <EventDateBoxComponent date={day.date} />
                </Col>
                <Col xs={24} sm={24} md={21}>
                  {items}
                </Col>
              </Row>
            );
          }

          return (
            <div>
              <Row>
                <Col xs={24}>
                  <Divider>
                    {t('week')} {item.weekOfYear} - {item.year}
                  </Divider>
                </Col>
              </Row>
              {days}
            </div>
          );
        }}
      />
    );
  };

  return (
    <Row>
      <Col xs={24}>{renderList()}</Col>
    </Row>
  );
}
